import React from "react";
import { Link, useLocation } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { INavbarItem } from "../../../Interfaces/NavbarInterfaces";
import { ClickAwayListener } from "@mui/base";

interface INavbarItemProps extends INavbarItem {
  openItemId?: number;
  setOpenItemId?: React.Dispatch<React.SetStateAction<number>>;
}

const NavbarItem = ({
  address,
  title,
  children,
  id,
  openItemId,
  setOpenItemId,
}: INavbarItemProps) => {
  const location = useLocation();
  React.useEffect(() => {
    if (id && openItemId && setOpenItemId)
      if (openItemId === id) setOpenItemId(-1);
  }, [location]);

  const clickHandler = () => {
    if (!setOpenItemId || !id) return;
    if (id === openItemId) setOpenItemId(-1);
    else setOpenItemId(id);
  };

  const checkActive = () => {
    if (!children || !children.length) return false;
    const isActive = children.find(
      (child) => "/" + child.address === location.pathname,
    );
    if (isActive) return true;
    return false;
  };

  if (children && id && openItemId && setOpenItemId)
    return (
      <div
        className={`bg-sky-600 text-white hover:text-blue-100 text-sm ${
          checkActive() ? "border-b-2 border-white" : ""
        }`}
      >
        <div
          onClick={clickHandler}
          className="flex flex-row justify-start items-center cursor-pointer"
        >
          {title}
          {openItemId !== id ? (
            <ExpandMoreIcon className="clickable-icon text-white expand-more-less-icon" />
          ) : (
            <ExpandLessIcon className="clickable-icon text-white expand-more-less-icon" />
          )}
        </div>
        {openItemId === id ? (
          <ClickAwayListener
            onClickAway={() => {
              if (setOpenItemId) setOpenItemId(-1);
            }}
          >
            <div className="absolute p-2 flex flex-col justify-start items-start gap-2 rounded border-2 border-white bg-sky-600 z-[102]">
              {children.map((child) => {
                return (
                  <NavbarItem
                    id={child.id}
                    openItemId={openItemId}
                    setOpenItemId={setOpenItemId}
                    key={child.title}
                    title={child.title}
                    address={child.address}
                    children={child.children}
                  />
                );
              })}
            </div>
          </ClickAwayListener>
        ) : (
          <></>
        )}
      </div>
    );
  if (address)
    return (
      <div
        className={`bg-sky-600 text-white hover:text-blue-100 text-sm whitespace-nowrap ${
          location.pathname === "/" + address
            ? "pb-0.5 border-b-2 border-white"
            : ""
        }`}
      >
        <Link to={address}>{title}</Link>
      </div>
    );
  else return <></>;
};

export default NavbarItem;
